import { ApolloError } from '@apollo/client'

export const GLOBAL_AUDIENCE_READ_ONLY_MESSAGE =
  'This is a global question. Its wording and options can only be edited in the base market.'

const normalise = (text: string | undefined): string =>
  (text ?? '').toLowerCase().replace(/[^a-z]/g, '')

/**
 * The backend rejects a structural edit to a global custom audience question in
 * a non-base market with a `GlobalAudienceReadOnlyError`. It surfaces as a
 * GraphQL error, so detect it from either the error code (extensions.code) or
 * the message. Normalising strips case/underscores so both
 * `GlobalAudienceReadOnlyError` and `GLOBAL_AUDIENCE_READ_ONLY` match.
 */
export const isGlobalAudienceReadOnlyError = (
  error: ApolloError | undefined
): boolean => {
  if (!error) {
    return false
  }
  const needle = 'globalaudiencereadonly'
  if (normalise(error.message).includes(needle)) {
    return true
  }
  return error.graphQLErrors.some((err) => {
    const code = err.extensions.code
    return (
      (typeof code === 'string' && normalise(code).includes(needle)) ||
      normalise(err.message).includes(needle)
    )
  })
}
